// extracted by mini-css-extract-plugin
export default {"id":"CameraTableRow_id__9YddB","btnItems":"CameraTableRow_btnItems__o9m3c","btnSVG":"CameraTableRow_btnSVG__THRCp","addPhoto":"CameraTableRow_addPhoto__5fmNZ"};